import ReceiverLanding from 'features/v2a/receiver/screens/ReceiverLanding/ReceiverLanding';
import React from 'react';

export default function Page() {
  return <ReceiverLanding />;
}
